/**
 * DonutChart + PieChart — DS Chart (partagé)
 */

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import styles from './DonutChart.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DonutChartProps {
  labels: string[];
  data: number[];
  title?: string;
  pie?: boolean;
  height?: number;
  className?: string;
}

const PALETTE = ['#9333ea', '#16a34a', '#2563eb', '#d97706', '#dc2626', '#0891b2'];

export function DonutChart({ labels, data, title, pie = false, height = 220, className = '' }: DonutChartProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {title && <h4 className={styles.title}>{title}</h4>}
      <div style={{ height }}>
        <Doughnut
          data={{
            labels,
            datasets: [{ data, backgroundColor: PALETTE.slice(0, data.length), borderWidth: 2, borderColor: '#fff' }],
          }}
          options={{
            responsive: true, maintainAspectRatio: false,
            cutout: pie ? '0%' : '60%',
            plugins: { legend: { position: 'right', labels: { font: { family: 'Inter' }, boxWidth: 12 } } },
          }}
        />
      </div>
    </div>
  );
}

export function PieChart(props: Omit<DonutChartProps, 'pie'>) {
  return <DonutChart {...props} pie />;
}
